var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('span', {
    staticClass: "checkbox-container"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": _vm.id
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.emitChange
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.id
    }
  })])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-211b883a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-211b883a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/components/form/checkbox.vue
// module id = 275
// module chunks = 3